const normalizeYearValue = (value: unknown): number | undefined => {
  if (value === undefined || value === null || value === '') return undefined;
  if (typeof value === 'number') return Number.isInteger(value) ? value : undefined;
  if (value instanceof Date) return value.getUTCFullYear();

  if (typeof value === 'string') {
    const parsedDate = new Date(value);
    if (!Number.isNaN(parsedDate.getTime())) return parsedDate.getUTCFullYear();

    const parsedNumber = Number(value);
    return Number.isInteger(parsedNumber) ? parsedNumber : undefined;
  }

  return undefined;
};

export const yearValueToDate = (value: unknown): Date | undefined => {
  const year = normalizeYearValue(value);
  return year === undefined ? undefined : new Date(year, 0, 1);
};

export default normalizeYearValue;
